import { useTranslation } from 'react-i18next'
import ErrorPage from './ErrorPage'

export default function Forbidden() {
  const { t } = useTranslation()

  return (
    <ErrorPage
      status={403}
      title={t('errors.pages.403.title')}
      message={t('errors.pages.403.message')}
      showHomeButton={true}
      showBackButton={true}
    />
  )
}
